export default __webpack_public_path__ + "static/media/mariog12.e1ac8a82.jpg";